import styled, { css } from 'styled-components';
import { down } from 'styled-breakpoints';

type TheaterButtonContainerProps = {
  $variant?: 'default' | 'player' | 'controls';
};

export const TheaterButtonContainer = styled.button<TheaterButtonContainerProps>`
  ${({ theme, $variant = 'default' }) => css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    font-weight: 500;
    transition: all 0.2s ease;

    ${$variant === 'default' &&
    css`
      background: ${theme.colors.background[80]};
      color: ${theme.colors.foreground[60]};

      &:hover {
        background: ${theme.colors.background[60]};
        color: ${theme.colors.foreground[100]};
      }
    `}

    ${$variant === 'player' &&
    css`
      background: rgba(255, 255, 255, 0.2);
      color: white;

      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    `}

    ${$variant === 'controls' &&
    css`
      background: transparent;
      color: #fff;
      padding: 0;
      gap: 0.375rem;
      font-size: 0.75rem;
      border-radius: 0.25rem;
      height: 2.5rem;
      padding: 0 0.5rem;

      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }

      &:active {
        background: rgba(255, 255, 255, 0.2);
      }

      svg {
        width: 1.125rem;
        height: 1.125rem;
      }
    `}

    svg {
      width: 1.125rem;
      height: 1.125rem;
    }

    ${down('md')} {
      display: none;
    }
  `};
`;

export const FloatingChatButton = styled.button`
  ${({ theme }) => css`
    position: fixed;
    bottom: 1.5rem;
    right: 1.5rem;
    width: 3.5rem;
    height: 3.5rem;
    background: ${theme.colors.brand.secondary.default};
    border-radius: 9999px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    transition: all 0.2s ease;
    z-index: 20;

    &:hover {
      transform: scale(1.1);
      background: ${theme.colors.brand.secondary.hover};
    }

    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  `};
`;

export const FloatingBadge = styled.span`
  ${() => css`
    position: absolute;
    top: -0.25rem;
    right: -0.25rem;
    min-width: 1.25rem;
    height: 1.25rem;
    padding: 0 0.25rem;
    background: #ef4444;
    color: white;
    font-size: 0.75rem;
    font-weight: 700;
    border-radius: 9999px;
    display: flex;
    align-items: center;
    justify-content: center;
  `};
`;
